/**
 * QA fixture staging availability — disabled unless REACT_APP_ALLOW_QA_FIXTURES=true at build time.
 * Sample preview mode (localStorage-only demos) is separate and remains available to admins.
 */

export const QA_FIXTURES_ALLOWED = process.env.REACT_APP_ALLOW_QA_FIXTURES === 'true';

export const QA_FIXTURES_DISABLED_TEST_ID = 'qa-fixtures-disabled-notice';

export function areQaFixturesAllowed() {
  return QA_FIXTURES_ALLOWED;
}
